(function () {
  'use strict';

  angular
    .module('factories.contentCache', ['factories.mobileHelper', 'factories.documentService'])
    .factory('ContentCache', ContentCache);

  ContentCache.$inject = ['MobileHelper', 'NativeBridge', '$rootScope', 'DocumentService'];

  function ContentCache(MobileHelper, NativeBridge, $rootScope, DocumentService) {
    var cacheUtils;
    var lookAheadsInProgress = {};

    function instantiateUtils() {
      cacheUtils = {
        createCacheSlideDownloadJobs: createCacheSlideDownloadJobs,
        prepareCacheForSlide: prepareCacheForSlide,
        cacheSliderThumbs: cacheSliderThumbs,
        emptyContentCache: emptyContentCache,
        cacheAssetsInJSON: cacheAssetsInJSON,
        createCacheDashboardCModuleDownloadJobs: createCacheDashboardCModuleDownloadJobs,
        prepareCacheForDashboardCModule: prepareCacheForDashboardCModule,
        cacheLookAheadSlideData: cacheLookAheadSlideData
      }
    }

    function createCacheSlideDownloadJobs(data, callback) {
      if (MobileHelper.isNativeIpadApp) {
        NativeBridge.fireHandler('createCacheSlideDownloadJobs', JSON.stringify(data),
          function () {
            $rootScope.$apply(callback());
          }
        );
      } else if (callback) {
        setTimeout(function () {
          $rootScope.$apply(callback.bind(cacheUtils));
        }, 50);
      }
    }

    function prepareCacheForSlide(slideNum, slideData, callback) {
      if (MobileHelper.isNativeIpadApp) {
        NativeBridge.fireHandler('prepareCacheForSlide', slideNum + '<delim>' + JSON.stringify(slideData),
          function (reponseData) {
            $rootScope.$apply(callback(reponseData));
          }
        );
      } else if (callback) {
        setTimeout(function () {
          $rootScope.$apply(callback.bind(cacheUtils, JSON.stringify(slideData)));
        }, 50);
      }
    }

    function cacheSliderThumbs(urlTemplate, numSlides, numSlidesPerChunk, callback) {
      if (!MobileHelper.isNativeIpadApp) {
        return;
      }

      var urls = '';
      var numChunks = Math.ceil(numSlides / numSlidesPerChunk);
      for (var i = 0; i < numChunks; i++) {
        if (urls.length > 0) {
          urls = urls + '<delim2>';
        }
        urls = urls + urlTemplate.replace('{0}', i);
      }

      if (!MobileHelper.isNativeIpadApp) {
        return;
      }
      NativeBridge.fireHandler('cacheSliderThumbs', urlTemplate + '<delim1>' + urls, callback);
    }

    function cacheAssetsInJSON(properties, callback) {
      if (MobileHelper.isNativeIpadApp) {
        NativeBridge.fireHandler('cacheAssetsInJSON', JSON.stringify(properties),
          function (reponseData) {
            $rootScope.$apply(callback(reponseData));
          }
        );
      } else {
        setTimeout(function () {
          $rootScope.$apply(callback.bind(cacheUtils, JSON.stringify(properties)));
        }, 50);
      }
    }

    function createCacheDashboardCModuleDownloadJobs(data, callback) {
      if (MobileHelper.isNativeIpadApp) {
        NativeBridge.fireHandler('createCacheDashboardCModuleDownloadJobs', JSON.stringify(data),
          function () {
            $rootScope.$apply(callback());
          }
        );
      } else if (callback) {
        setTimeout(function () {
          $rootScope.$apply(callback.bind(cacheUtils));
        }, 50);
      }
    }

    function prepareCacheForDashboardCModule(cModuleData, callback) {
      if (MobileHelper.isNativeIpadApp) {
        NativeBridge.fireHandler('prepareCacheForDashboardCModule', JSON.stringify(cModuleData),
          function (reponseData) {
            $rootScope.$apply(callback(reponseData));
          }
        );
      } else if (callback) {
        setTimeout(function () {
          $rootScope.$apply(callback.bind(cacheUtils, JSON.stringify(cModuleData)));
        }, 50);
      }
    }

    function emptyContentCache() {
      NativeBridge.fireHandler('emptyContentCache');
    }

    function cacheLookAheadSlideData(cModule, slides) {
      for (var i = 0; i < slides.length; i++) {
        var slide = slides[i];
        if (!slide) continue;

        checkCrocodocSessionCaching(i + 1, cModule, slide);
        // add any more look ahead calls here
      }
    }

    function checkCrocodocSessionCaching(distance, cModule, slide) {
      if (!slide
        || slide.__type != "MultiPageSlideInfo"
        || distance > 2
        || isLookAheadInProgress(slide.id, "crocodoc")) return;
      var session = slide.crocodocSessInfo;
      if (session) {
        if (session.lastAdjusted) {
          var lastAdjusted = new Date(session.lastAdjusted);
          var ttl = session.timeToLiveSeconds - Math.floor((Date.now() - lastAdjusted.getTime()) / 1000);
          if (ttl < 30) { // leaving some room for error
            session = null;
          }
        } else {
          session = null;
        }
      }

      if (session) return; // already have a valid session

      slide.crocodocSessInfo = null;
      setLookAheadInProgress(slide.id, "crocodoc");
      DocumentService.createSession(cModule.id, slide.id, function (sessInfo) {
        if (sessInfo && sessInfo.cModuleId == cModule.id && sessInfo.frameId == slide.id) {
          sessInfo.lastAdjusted = new Date().toISOString();
          slide.crocodocSessInfo = sessInfo;
        }
        removeLookAheadInProgress(slide.id, "crocodoc");
      }, function (err) {
        removeLookAheadInProgress(slide.id, "crocodoc");
        return true; // no need to show modal error, it will retry on actual slide
      });
    }

    function setLookAheadInProgress(slideId, name) {
      if (!lookAheadsInProgress[slideId]) lookAheadsInProgress[slideId] = {};
      lookAheadsInProgress[slideId][name] = 1;
    }

    function isLookAheadInProgress(slideId, name) {
      return lookAheadsInProgress[slideId] && lookAheadsInProgress[slideId][name] === 1;
    }

    function removeLookAheadInProgress(slideId, name) {
      if (!lookAheadsInProgress[slideId]) lookAheadsInProgress[slideId] = {};
      lookAheadsInProgress[slideId][name] = 0;
    }

    if (!cacheUtils)
      instantiateUtils();

    return cacheUtils;
  }

})();
